import React from 'react';
import { Link } from 'react-router-dom';
import Nav from '../components/Nav/Nav';

function Cookies() {
  return (
    <div>
      <Nav />
      <div className='wrapper-container legal-container'>
        <div className='wrapper-content'>

          <div className='title-wrapper'>
            <h2>Politique de cookies</h2>
          </div>

          <p>
            La présente politique explique l’utilisation des cookies et traceurs sur la plateforme Fastline.
          </p>

          <br />

          <h2><strong>1. Qu’est-ce qu’un cookie ?</strong></h2>
          <p>
            Un cookie est un fichier déposé sur votre appareil lors de votre navigation.
            Il permet notamment d’assurer le bon fonctionnement du site et de mesurer son utilisation.
          </p>

          <br />

          <h2><strong>2. Cookies utilisés</strong></h2>

          <p><strong>Cookies techniques (obligatoires)</strong></p>
          <p>
            Ces cookies sont nécessaires au fonctionnement du site, notamment pour :
          </p>
          <ul>
            <li>la connexion et l’authentification (Firebase)</li>
            <li>la sécurité des comptes</li>
            <li>le fonctionnement des commandes</li>
          </ul>
          <p>
            Ils ne peuvent pas être désactivés.
          </p>

          <br />

          <p><strong>Cookies de mesure d’audience</strong></p>
          <p>
            Fastline utilise Google Analytics et Firebase Analytics afin d’analyser l’utilisation du site,
            mesurer l’audience et améliorer les performances de la plateforme.
          </p>

          <br />

          <p><strong>Cookies marketing</strong></p>
          <p>
            Des traceurs peuvent être utilisés à des fins publicitaires, notamment via Meta (Facebook Pixel),
            afin de mesurer l’efficacité des campagnes et proposer des contenus adaptés.
          </p>

          <br />

          <h2><strong>3. Consentement</strong></h2>
          <p>
            Les cookies non essentiels (mesure d’audience et marketing) nécessitent le consentement préalable de l’utilisateur.
          </p>
          <p>
            À ce jour, Fastline travaille à la mise en place d’un mécanisme de gestion du consentement permettant
            d’accepter ou de refuser ces cookies.
          </p>

          <br />

          <h2><strong>4. Gestion des cookies</strong></h2>
          <p>
            Vous pouvez configurer votre navigateur pour refuser ou supprimer les cookies.
          </p>
          <p>
            La désactivation de certains cookies peut affecter le fonctionnement du site.
          </p>

          <br />

          <h2><strong>5. Données personnelles</strong></h2>
          <p>
            Les données collectées via les cookies sont traitées conformément à notre{" "}
            <Link to="/privacy-policy" style={{textDecoration:'underline'}}>Politique de confidentialité</Link>.
          </p>

        </div>
      </div>
    </div>
  );
}

export default Cookies;